import { DatePipe, KeyValuePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../../misc.module';
import { FilterPageRoutingModule } from './filter-routing.module';
import { FilterPageComponent } from './filter.component';

@NgModule({
  declarations: [FilterPageComponent],
  imports: [
    FilterPageRoutingModule,
    IonicModule,
    TitleCasePipe,
    KeyValuePipe,
    MiscModule,
    DatePipe,
    ReactiveFormsModule
  ]
})
export class FilterPageModule {}
